import { IAnalyticsEventField, IAnalyticsFieldArgument } from './types';
import { getFieldEventProperties } from './utils';

export const fieldInformationUpdated = (
  field: IAnalyticsFieldArgument,
): IAnalyticsEventField => {
  return {
    eventName: 'Field Information Updated',
    ...getFieldEventProperties(field),
  };
};
